import './Tile.css';
import { DailyVideo, useVideoTrack } from '@daily-co/daily-react';
import Username from '../Username/Username';
import { Button } from '@mui/material';
import MinimizeIcon from '@mui/icons-material/Minimize';
import MaximizeIcon from '@mui/icons-material/Maximize';

interface TileProps {
  id: string;
  isScreenShare?: boolean;
  isLocal?: boolean;
  isAlone?: boolean;
  isMinimized?: boolean;
  toggleMinimize?: () => void;
  /** Video fit for remote (non-screenshare) tiles; local self-view and screenshares always use cover. */
  fit?: 'cover' | 'contain';
  /** Letterbox colour shown around the video when fit is 'contain'. */
  fitBackground?: string;
}

export default function Tile({ id, isScreenShare, isLocal, isAlone, isMinimized, toggleMinimize, fit = 'cover', fitBackground }: TileProps) {
  const videoState = useVideoTrack(id);

  let containerCssClasses = isScreenShare ? 'tile-screenshare' : 'tile-video';

  if (isLocal) {
    containerCssClasses += ' self-view';
    if (isAlone) {
      containerCssClasses += ' alone';
    }
    if (isMinimized) {
      containerCssClasses += ' minimized';
    }
  }

  if (videoState.isOff) {
    containerCssClasses += ' no-video';
  }

  const useFit = !isLocal && !isScreenShare ? fit : 'cover';
  const containStyle = useFit === 'contain' && !videoState.isOff && fitBackground ? { backgroundColor: fitBackground } : undefined;

  return (
    <div className={containerCssClasses} style={containStyle}>
      <DailyVideo fit={useFit} automirror sessionId={id} type={isScreenShare ? 'screenVideo' : 'video'} />
      {!isScreenShare && <Username id={id} isLocal={isLocal} />}
      {isLocal && (
        <div className="minimize-button">
          <Button variant="contained" onClick={toggleMinimize}>
            {isMinimized ? <MaximizeIcon /> : <MinimizeIcon />}
          </Button>
        </div>
      )}
    </div>
  );
}
